import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import classNames from 'classnames/bind';
import styles from './ManageMailTo.module.scss';
import GlobalStateContext from '~/GlobalStateContext ';
import API_URL from '~/config';

const cx = classNames.bind(styles);

function ManageMailto() {
    const { token } = useContext(GlobalStateContext);
    const [loading, setLoading] = useState(true);
    const [isSuperAdmin, setIsSuperAdmin] = useState(true);
    const [error, setError] = useState('');
    const [mailTos, setMailTos] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
    });
    const [editingMailTo, setEditingMailTo] = useState(null);

    const fetchAdmins = async () => {
        try {
            const response = await axios.get(`${API_URL}/admins`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setLoading(false);
        } catch (error) {
            console.error('Error fetching admins:', error);
            setIsSuperAdmin(false);
            setError('Unauthorized');
            setLoading(false);
        }
    };

    const fetchMailTos = async () => {
        try {
            const response = await axios.get(`${API_URL}/mail-to`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setMailTos(response.data.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching mailTos:', error);
            setError('Unauthorized');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAdmins();
    }, []);


    useEffect(() => {
        fetchMailTos();
    }, []);



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleCancel = () => {
        setFormData({
            name: '',
            email: '',
        });
        setEditingMailTo(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingMailTo) {
                await axios.put(`${API_URL}/mail-to/${editingMailTo.id}`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                alert('MailTo updated successfully');
            } else {
                await axios.post(`${API_URL}/mail-to`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                alert('MailTo created successfully');
            }
            setFormData({
                name: '',
                email: '',
            });
            setEditingMailTo(null);
            fetchMailTos();
        } catch (error) {
            alert(`Error: ${error.response.data.message}`);
        }
    };

    const handleEdit = (mailTo) => {
        setFormData({
            name: mailTo.name,
            email: mailTo.email,
        });
        setEditingMailTo(mailTo);
    };

    const handleDelete = async (id, email) => {
        const confirmDelete = window.confirm(`Do you want to delete the mailTo with email: ${email}?`);
        if (!confirmDelete) {
            return;
        }

        try {
            await axios.delete(`${API_URL}/mail-to/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            alert('MailTo deleted successfully');
            if (editingMailTo && editingMailTo.id === id) {
                setFormData({
                    name: '',
                    email: '',
                });
                setEditingMailTo(null);
            }
            fetchMailTos();
        } catch (error) {
            alert(`Error deleting mailTo: ${error.response.data.message}`);
        }
    };

    if (loading) {
        return <div className={cx('loading')}>Loading...</div>;
    }

    if (error) {
        return <div className={cx('error')}>{error}</div>;
    }

    return (
        <div className={cx('mailto-manager')}>
            <h2>Admin Notification Email Setup</h2>
            <form className={cx('mailto-form')} onSubmit={handleSubmit}>
                {editingMailTo && (
                    <div className={cx('form-group')}>
                        <label>ID</label>
                        <input
                            type="text"
                            name="id"
                            value={editingMailTo.id}
                            disabled={true}
                            className={cx('input')}
                        />
                    </div>
                )}
                <div className={cx('form-group')}>
                    <label>Name</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className={cx('input')}
                    />
                </div>
                <div className={cx('form-group')}>
                    <label>Email</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className={cx('input')}
                    />
                </div>
                <div className={cx('button-group')}>
                    <button type="submit" className={cx('button', 'submit-button')}>
                        {editingMailTo ? 'Update' : 'Create'}
                    </button>
                    {editingMailTo && (
                        <button type="button" onClick={handleCancel} className={cx('button', 'cancel-button')}>
                            Cancel
                        </button>
                    )}
                </div>
            </form>
            <table className={cx('styled-table')}>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {mailTos.map((mailTo) => (
                        <tr key={mailTo.id}>
                            <td>{mailTo.name}</td>
                            <td>{mailTo.email}</td>
                            <td>
                                <button onClick={() => handleEdit(mailTo)} className={cx('button', 'edit-button')}>
                                    Edit
                                </button>
                                <button onClick={() => handleDelete(mailTo.id, mailTo.email)} className={cx('button', 'delete-button')}>
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ManageMailto;